var map = {
	"./wrapper-modules/administration-wrapper.module": [
		"./src/app/wrapper-modules/administration-wrapper.module.ts",
		"wrapper-modules-administration-wrapper-module"
	],
	"./wrapper-modules/marketplace-partners-wrapper.module": [
		"./src/app/wrapper-modules/marketplace-partners-wrapper.module.ts",
		"wrapper-modules-marketplace-partners-wrapper-module"
	],
	"./wrapper-modules/marketplace-wrapper.module": [
		"./src/app/wrapper-modules/marketplace-wrapper.module.ts",
		"wrapper-modules-marketplace-wrapper-module"
	],
	"./wrapper-modules/pim-wrapper.module": [
		"./src/app/wrapper-modules/pim-wrapper.module.ts",
		"wrapper-modules-pim-wrapper-module"
	],
	"./wrapper-modules/playground-wrapper.module": [
		"./src/app/wrapper-modules/playground-wrapper.module.ts",
		"wrapper-modules-playground-wrapper-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;